import type { ResourcesConfig } from 'aws-amplify'

const getRelyingPartyId = (): string => {
  const hostname = window.location.hostname

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'localhost'
  }

  if (hostname.endsWith('lucenthealth.com')) {
    return 'lucenthealth.com'
  }

  return hostname
}

export const createAwsConfig = (): ResourcesConfig => {
  const userPoolId = window.env.COGNITO_POOL_ID ?? ''
  const userPoolClientId = window.env.COGNITO_CLIENT_ID ?? ''
  const identityPoolId = window.env.COGNITO_IDENTITY_POOL_ID ?? ''
  const relyingPartyId = getRelyingPartyId()
  const domain = window.env.COGNITO_DOMAIN

  const cognitoAuth: NonNullable<ResourcesConfig['Auth']>['Cognito'] & {
    loginWith?: Record<string, unknown>
  } = {
    userPoolId,
    userPoolClientId,
    identityPoolId
  }
  const loginWith: Record<string, unknown> = {
    email: true,
    username: false,
    passkey: { relyingPartyName: 'Lucent Health', relyingPartyId, userVerification: 'preferred' }
  }

  if (domain) {
    loginWith.oauth = {
      domain,
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: window.location.origin,
      redirectSignOut: window.location.origin,
      responseType: 'code'
    }
  }

  cognitoAuth.loginWith = loginWith

  return {
    Auth: {
      Cognito: cognitoAuth
    }
  }
}

export const awsConfig = createAwsConfig()
